import { Box, Stack, Typography } from "@mui/material"
import { useData } from "../../../utils/useData"
import { formatCurrency } from "../../../utils/formatters";
import { ModuleFeeTooltip } from "../Standard/Tooltips/ModuleFeeTooltip";

export const RewardsCheckoutProductDetails = ({ monthlyUserFee }: { monthlyUserFee: number }) => {
    return (
        <Box>
            <Typography variant="h6" paddingBottom={2}>Module Information</Typography>
            <Typography textAlign={"justify"}>Extraordinary’s digital gifting platform gives businesses a cost-effective, breakage-free way to reward employees. Create custom programs in minutes, distribute digital cards instantly, and only pay for what’s actually redeemed. No lost cards, no expired balances, and no FBT on unused funds. With real-time tracking and full control, you save money while delivering a better, more meaningful experience for your team.</Typography>
            
            <Stack direction={"row"} sx={{marginTop: 8, marginBottom: 1}} alignItems={"center"}>
                <Typography variant="h6" textAlign={"justify"}>Module Fee</Typography>
                <ModuleFeeTooltip />
            </Stack>
            
            <Typography textAlign={"justify"}>{formatCurrency(monthlyUserFee)}/month per user</Typography>
        </Box>
    )
}